import { RSAA } from 'redux-api-middleware';
import config from 'config';

export const scheduleCycle = (cycleDto) => {

  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/swim/cycle`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cycleDto),
      types: [
        'SCHEDULE_CYCLE_REQUEST',
        'SCHEDULE_CYCLE_SUCCESS',
        'SCHEDULE_CYCLE_FAILURE'

      ]
    }
  };
};
export const resetSuccess = () => {
  return {
    type: "RESET_SUCCESS_MESSAGE_CYCLE_SCHEDULER"

  }
}
